const changeExamSagaNamespace = 'changeExam';
export const LOAD_RATES = `${changeExamSagaNamespace}/LOAD_RATES`;
export const LOAD_EXAMS = `${changeExamSagaNamespace}/LOAD_EXAMS`;
